import { Grid, Tab, Tabs } from '@material-ui/core';
import DonutChart from 'components/common/chart/DonutChart';
import CustomSpan from 'components/common/text/CustomSpan';
import CustomText from 'components/common/text/CustomText';
import ProgressBarCard from 'components/dashboard/ProgressBarCard';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { color } from 'styles/utils';
import { icon_product_data } from 'components/base/images';
import { a11yProps } from 'lib/library';
import TabPanel from 'components/common/tab/TabPanel';
import { DashboardActions } from 'store/actionCreators';
import { useShallowAppSelector } from 'store/hooks';
import { useTranslation } from 'react-i18next';
import T from 'components/common/text/T';
import { useDidUpdateEffect } from 'lib/utils';
import CircularLoading from 'components/base/loading/CircularLoading';
import ListEmpty from 'components/common/list/ListEmpty';
import { PageSubTitle } from 'components/base/title/PageTitle';
interface StoreContainerProps {
  className?: string;
}

function StoreContainer({ className }: StoreContainerProps) {
  const {
    productData: {
      dataInfo: { isExpired, productName, totalSize, totalUsage },
    },
    productDataSuccess,
    productDataPending,
    productDataFailure,
  }: {
    productData: {
      dataInfo: {
        isExpired: number;
        productName: string;
        totalSize: number;
        totalUsage: number;
      };
    };
    productDataSuccess: boolean;
    productDataPending: boolean;
    productDataFailure: boolean;
  } = useShallowAppSelector(state => ({
    productData: state.dashboard.productData.data || {
      dataInfo: {
        isExpired: 0,
        productName: 'Basic',
        totalSize: 5,
        totalUsage: 0,
      },
    },
    productDataSuccess: state.dashboard.productData.success,
    productDataPending: state.dashboard.productData.pending,
    productDataFailure: state.dashboard.productData.failure,
  }));
  const { t } = useTranslation();
  const [myProductTab, setMyProductTab] = useState(0);
  const [isLoadSuccess, setIsLoadSuccess] = useState<boolean>(false);
  const [isLoadFailure, setIsLoadFailure] = useState<boolean>(false);

  // TODO: isExpired 시 표시 추가
  const syncItemName = productName; // productName
  const syncItemUseVolume = Number(totalUsage); // totalUsage
  const syncItemVolume = Number(totalSize); // totalSize

  const syncChartItems = [
    { title: 'available', value: syncItemVolume - syncItemUseVolume, color: '#F4F5FA' },
    { title: syncItemName, value: syncItemUseVolume, color: color.blue },
  ];

  const warrantyItems = [
    {
      serial: 1,
      name: 'Freedom',
      startPeriod: 1628446354,
      endPeriod: 1628891159,
    },
  ];

  const licenseItems = [
    {
      serial: 1,
      name: 'ScanApp',
      startPeriod: 1628446354,
      endPeriod: 1628891159,
    },
  ];

  const myProductTabList = [t('GLOBAL_DATA')];

  const handleRefreshList = () => {
    DashboardActions.fetch_product_data_request();
    setIsLoadSuccess(false);
    setIsLoadFailure(false);
  };

  useEffect(() => {
    DashboardActions.fetch_product_data_request();
    return () => {
      setIsLoadSuccess(false);
      setIsLoadFailure(false);
    };
  }, []);

  useDidUpdateEffect(() => {
    if (!productDataSuccess) return;
    setIsLoadSuccess(true);
  }, [productDataSuccess]);
  useDidUpdateEffect(() => {
    if (!productDataFailure) return;
    setIsLoadFailure(true);
  }, [productDataFailure]);

  return (
    <StyledStore data-component-name="Store" item className={className}>
      <div className="dashboard__card_title_box">
        <h2 className="dashboard__card_title">
          <PageSubTitle title="HOME_TITLE_MY_PRODUCT" margin="0" />
        </h2>
      </div>

      <div className="dashboard__store_content_box box-shadow-default">
        <Tabs
          value={myProductTab}
          onChange={(e: any, value: any) => setMyProductTab(value)}
          aria-label="myproduct tabs"
          className="dashboard__store_tabs"
        >
          {/* TODO: 추후 Warranty, License 추가 */}
          {/* {['Data', 'Warranty', 'License'].map((item, idx) => (*/}
          {/* {['Data'].map((item, idx) => ( */}
          {myProductTabList.map((item, idx) => (
            <Tab
              className="dashboard__store_tab"
              key={idx}
              label={item}
              disableRipple
              {...a11yProps(idx, 'myProductTab')}
            />
          ))}
        </Tabs>

        <TabPanel
          value={myProductTab}
          index={0}
          name="myProductTab"
          className="dashboard__store_tabpanel"
        >
          <div className="dashboard__store_tabpanel_data_content_box">
            <div className="dashboard__store_tabpanel_content data">
              {!isLoadSuccess && productDataPending && (
                <div className="infinite-scroll-loading">
                  <CircularLoading />
                </div>
              )}
              {!!isLoadSuccess && (
                <>
                  <div className="dashboard__store_tabpanel_chart">
                    <div className="dashboard__store_tabpanel_chart_out_style">
                      <DonutChart
                        data={syncChartItems as any}
                        width={190}
                        bgColor="transparent"
                        lineWidth={8}
                        rounded
                        startAngle={
                          -90 -
                          (360 * syncChartItems[0].value) /
                            (syncChartItems[0].value + syncChartItems[1].value)
                        }
                      >
                        <div className="dashboard__store_tabpanel_product_box">
                          <div className="dashboard__store_tabpanel_product_box_in_box">
                            <div className="dashboard__store_tabpanel_product">
                              <img src={icon_product_data} alt="data" />
                              <CustomText
                                fontSize={14}
                                fontColor={color.navy_blue}
                                fontWeight={500}
                                marginTop={10}
                              >
                                {syncChartItems[1].title}
                              </CustomText>
                            </div>
                          </div>
                        </div>
                      </DonutChart>
                    </div>
                  </div>
                  <div className="dashboard__store_tabpanel_chart_info_box">
                    <div className="dashboard__store_tabpanel_chart_info">
                      <div className="dashboard__store_tabpanel_chart_info_label">
                        <span
                          className="dashboard__store_tabpanel_chart_info_circle"
                          style={{
                            backgroundColor: syncChartItems[1].color,
                          }}
                        ></span>
                        <T>DATA_USAGE_CAPACITY</T>
                      </div>
                      <div className="dashboard__store_tabpanel_chart_info_data">
                        <CustomSpan fontSize={20}>
                          {Math.ceil(syncChartItems[1].value * 100) / 100}
                        </CustomSpan>{' '}
                        <CustomSpan fontSize={14} fontColor="#7C7C7C">
                          GB
                        </CustomSpan>
                      </div>
                    </div>

                    <div className="dashboard__store_tabpanel_chart_info">
                      <div className="dashboard__store_tabpanel_chart_info_label">
                        <span
                          className="dashboard__store_tabpanel_chart_info_circle"
                          style={{
                            backgroundColor: '#E2E4EE',
                          }}
                        ></span>
                        <T>DATA_AVAILABLE_USAGE</T>
                      </div>
                      <div className="dashboard__store_tabpanel_chart_info_data">
                        <CustomSpan fontSize={20}>
                          {Math.floor(syncChartItems[0].value * 100) / 100}
                        </CustomSpan>{' '}
                        <CustomSpan fontSize={14} fontColor="#7C7C7C">
                          GB
                        </CustomSpan>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {!!isLoadFailure && (
                <ListEmpty
                  text="GLOBAL_LIST_ERROR"
                  isRefreshButton={true}
                  onRefresh={handleRefreshList}
                />
              )}
            </div>

            {/* TODO: 추후 추가 */}
            {/* <div className="dashboard__store_lack_box">
              <img src={icon_cloud_data} alt="cloud data" className="dashboard__store_cloud_icon" />
              <CustomSpan fontSize={15}>Are you running out of data?</CustomSpan>
              <MuiButton
                config={{
                  width: 100,
                  fontColor: color.blue,
                  fontSize: '13px',
                  fontWeight: 500,
                  color: 'white',
                }}
                disableElevation
                variant="contained"
                onClick={() => history.push(pageUrl.store.index)}
                className="sm border-radius-round"
              >
                Upgrade
              </MuiButton>
            </div> */}
          </div>
        </TabPanel>
        <TabPanel
          value={myProductTab}
          index={1}
          name="myProductTab"
          className="dashboard__store_tabpanel"
        >
          <div className="dashboard__store_tabpanel_content warranty">
            {!!warrantyItems?.length ? (
              <>
                {warrantyItems.map((item, idx) => (
                  <ProgressBarCard
                    key={item.serial}
                    name={item.name}
                    startPeriod={item.startPeriod}
                    endPeriod={item.endPeriod}
                  />
                ))}
              </>
            ) : (
              <div className="dashboard__store_tabpanel_no_data">
                There are no registered devices. <br />
                Register your device on My Page <br />
                or purchase a warranty.
              </div>
            )}
          </div>
        </TabPanel>
        <TabPanel
          value={myProductTab}
          index={2}
          name="myProductTab"
          className="dashboard__store_tabpanel"
        >
          <div className="dashboard__store_tabpanel_content license">
            {!!licenseItems?.length ? (
              <>
                {licenseItems.map((item, idx) => (
                  <ProgressBarCard
                    key={item.serial}
                    name={item.name}
                    startPeriod={item.startPeriod}
                    endPeriod={item.endPeriod}
                  />
                ))}
              </>
            ) : (
              <div className="dashboard__store_tabpanel_no_data">
                There is no license in use. <br />
                It can be used after purchase in the store.
              </div>
            )}
          </div>
        </TabPanel>
      </div>
    </StyledStore>
  );
}

const StyledStore = styled(Grid)`
  .dashboard__store_content_box {
    width: 395px;
    height: 400px;
    background-color: #fff;
    padding: 30px;
    border-radius: 10px;
    .dashboard__store_tabs {
      &:hover {
        cursor: default !important;
      }
      .dashboard__store_tab {
        min-width: 33.33%;
        min-height: auto;
        padding: 5px 0;
        &:hover {
          cursor: default !important;
        }
      }
    }
    .dashboard__store_tabpanel {
      height: calc(400px - 60px - 37px);

      .dashboard__store_tabpanel_data_content_box {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        height: 100%;
        width: 100%;
      }

      .dashboard__store_tabpanel_content {
        position: relative;
        width: 100%;
        height: 100%;
        &:not(.data) {
          overflow-y: overlay;
        }
        &.data {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-end;
          row-gap: 25px;
        }
      }
      .dashboard__store_tabpanel_no_data {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        height: 350px;
        font-size: 16px;
        line-height: 1.3;
        color: #7c7c7c;
      }
      .dashboard__store_tabpanel_chart {
        position: relative;
        margin-left: -10px;
        .dashboard__store_tabpanel_chart_out_style {
          position: relative;
          background-color: #f4f5fa;
          border-radius: 50%;
          padding: 2px;
          box-shadow: inset 1px 1px 2px rgba(0, 0, 0, 0.16);
          &:before {
            content: '';
            display: block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 170px;
            height: 170px;
            background-color: white;
            border-radius: 50%;
            box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.16);
          }
        }
        .dashboard__store_tabpanel_product_box {
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 100%;
          height: 100%;
          .dashboard__store_tabpanel_product_box_in_box {
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            width: 135px;
            height: 135px;
            border-radius: 50%;
            &:before,
            &:after {
              content: '';
              display: block;
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              border-radius: 50%;
            }
            &:before {
              box-shadow: -2px -2px 6px rgba(0, 0, 0, 0.04);
            }
            &:after {
              box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.16);
            }
          }
          .dashboard__store_tabpanel_product {
            text-align: center;
          }
        }
      }
      .dashboard__store_tabpanel_chart_info_box {
        display: flex;
        justify-content: space-between;
        column-gap: 40px;
        .dashboard__store_tabpanel_chart_info {
          .dashboard__store_tabpanel_chart_info_label {
            display: flex;
            align-items: center;
            font-size: 15px;
          }
          .dashboard__store_tabpanel_chart_info_circle {
            display: inline-block;
            margin-right: 10px;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: ${color.blue};
            &.available {
              background-color: #ddd;
            }
          }
          .dashboard__store_tabpanel_chart_info_title {
            font-size: 16px;
            color: ${color.black_font};
            display: inline-block;
            margin-left: 10px;
          }
          .dashboard__store_tabpanel_chart_info_data {
            margin-top: 14px;
            font-size: 16px;
            color: ${color.black_font};
            text-indent: 23px;
          }
        }
      }
    }

    .dashboard__store_lack_box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      height: 40px;
      padding: 5px;
      padding-left: 110px;
      background: rgb(0, 166, 226);
      background: linear-gradient(90deg, rgba(0, 166, 226, 1) 0%, rgba(8, 123, 238, 1) 100%);
      border-radius: 20px;
      color: white;
      .dashboard__store_cloud_icon {
        position: absolute;
        left: 0;
        bottom: 0;
      }
    }
  }
`;

export default React.memo(StoreContainer);
